import { Link } from 'react-router-dom';
import useCheckAuth from '../../hooks/auth/useCheckAuth.js';
import ROUTES from '../../routes/Routes.js';
import NavbarLinks from './NavbarLinks.jsx';
import NavbarActions from './NavbarActions.jsx';
import imgLogo from '../../images/navbar/logo.png';
import '../../css/components/Navbar.css';

export default function Navbar() {
    const { isAuthenticated, user } = useCheckAuth();

    return (
        <nav className="navbar navbar-expand-lg fixed-top bg-body-tertiary" id="navbar">
            <div className="container-fluid">
                <Link to={ROUTES.HOME} className="navbar-brand">
                    <img src={imgLogo} alt="Logo" style={{ width: '100%', height: '50px' }} />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <NavbarLinks
                        isAuthenticated={isAuthenticated}
                        user={user}
                    />
                    <NavbarActions
                        isAuthenticated={isAuthenticated}
                        user={user}
                    />
                </div>
            </div>
        </nav>
    );
}